<template>
  <div id="basic-master">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center mb-base">
        <div class="flex-grow">
          <div class="upper-controller">
            <template v-if="!isEditingOrder">
              <p>検索</p>
              <vs-input
                class="search-input"
                color="#2D9CDB"
                v-model="searchInput"
                placeholder="キーワードを入力"
                @keydown.enter="searchInputEnter"
              >
              </vs-input>
              <vs-button
                class="search-button"
                v-if="!incrementSearch"
                color="#2D9CDB"
                @click="callSearch"
              >
                検索
              </vs-button>
              <div class="display-items" v-if="pagination">
                <span>表示数</span>
                <v-select
                  class="display-items-select-box"
                  v-model="displayItemsTemp"
                  :options="displayItemsOptions"
                  label="number"
                  placeholder="選択してください"
                  :clearable="false"
                  :searchable="false"
                >
                  <template #selected-option="{}">
                    <div style="display: flex; align-items: baseline">
                      {{ displayItemsText }}
                    </div>
                  </template>
                </v-select>
              </div>
              <!-- 新規作成ボタンは使わない見込みであるため、コメントアウトする。削除機能のコメントアウト部分を消すときに一緒に削除予定 -->
              <!--vs-button
                class="add-button top-button"
                color="#2D9CDB"
                v-if="insertDataPageName"
                @click="toInsertPage"
              >
                <div class="button-inner">
                  <feather-icon class="mr-2" icon="PlusIcon" svgClasses="h-5 w-5" />
                  <span>新規登録</span>
                </div>
              </vs-button-->
              <div v-else class="add-button blank"></div>
              <vs-button
                class="order-button top-button border-button"
                color="#ffffff"
                @click="clickChangeOrder"
                v-if="sortable"
              >
                <div class="button-inner">
                  <feather-icon
                    class="mr-2"
                    icon="ListIcon"
                    svgClasses="h-5 w-5"
                  />
                  <span>表示順序変更</span>
                </div>
              </vs-button>
            </template>
            <template v-else>
              <span class="title">表示順序変更</span>
              <vs-button
                class="order-cancel-button top-button"
                @click="cancelEditOrder"
                color="#BDBDBD"
              >
                <div class="button-inner">
                  <span>キャンセル</span>
                </div>
              </vs-button>
              <vs-button
                class="order-save-button top-button"
                color="#2D9CDB"
                @click="callUpdateOrder"
              >
                <div class="button-inner">
                  <span>保存</span>
                </div>
              </vs-button>
            </template>
          </div>
          <div class="table-area">
            <div class="header row">
              <div class="cell index"></div>
              <div v-for="column in columns" :key="column.key">
                <div class="cell" :class="generateClassses(column)">
                  {{ column.displayName }}
                </div>
              </div>
            </div>
            <div
              class="content-row row"
              :class="{
                focused: isEditingId == rowData.id,
                ordered: isEditingOrder,
              }"
              v-for="(rowData, index) in filteredData"
              :key="rowData.id + '-' + index"
            >
              <span
                @click="clickRow(rowData.id)"
                class="main-columns"
                :class="{ clickable: isShowEditMenu }"
              >
                <div class="index cell">
                  {{
                    pagination && !isEditingOrder
                      ? indexFrom + index
                      : index + 1
                  }}
                </div>
                <div v-for="column in columns" :key="column.key" class="cell">
                  <editable-string-and-number-cell
                    v-if="
                      column.inputType == 'string' ||
                      column.inputType == 'textArea' ||
                      column.inputType == 'number'
                    "
                    class="cell"
                    :class="generateClassses(column)"
                    :value="rowData[column.key]"
                  >
                  </editable-string-and-number-cell>

                  <editable-time-cell
                    v-else-if="column.inputType == 'time'"
                    class="cell"
                    :class="generateClassses(column)"
                    :valueMap="rowData[column.key]"
                  >
                  </editable-time-cell>
                </div>
              </span>
              <!-- 以下は行削除機能だが、使わない見込みであるため、コメントアウト。仕様が確定した時に削除。-->
              <!--vs-dropdown class="more-button" color="#2D9CDB" :vs-trigger-click="true" v-if="!isEditingOrder && isEditingId != rowData.id">
                <feather-icon class="mr-2" icon="MoreVerticalIcon" svgClasses="h-5 w-5" />
                <vs-dropdown-menu class="more-button-dropdown">
                  <vs-dropdown-item @click="openDeletePopup(rowData)">
                    <span class="flex items-center">
                      <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                      <span>削除</span>
                    </span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown-->

              <div class="cell function" v-if="isEditingId == rowData.id">
                <template>
                  <vs-button
                    class="control-button"
                    color="#BDBDBD"
                    @click.native="cancelEdit"
                    >キャンセル</vs-button
                  >
                  <vs-button
                    class="control-button"
                    color="#2D9CDB"
                    @click.native="callSave"
                    :disabled="!dataChanged"
                    >保存</vs-button
                  >
                </template>
              </div>
            </div>
          </div>

          <vs-pagination
            class="master-pagination"
            v-if="pagination && !isEditingOrder"
            :total="totalPages"
            :max="5"
            v-model="currentPageTemp"
            color="#2D9CDB"
          />

          <!-- 削除機能は使わない見込みであるため、コメントアウト。仕様として使わないことが確定したら、削除する。-->
          <!--vs-popup class="basic-master-popup"  :title="masterName + 'の削除'" :active.sync="popupActive">
            <p>
              「{{deleteTarget.displayName}}」を削除してよろしいですか？
            </p>
            <div class="button-area">
              <vs-button class="popup-button" color="#BDBDBD" @click="closeDeletePopup">キャンセル</vs-button>
              <vs-button class="popup-button" color="#2D9CDB" @click="callDelete(deleteTarget.id)">削除</vs-button>
            </div>
          </vs-popup-->
        </div>
      </div>
    </div>
    <error-dialog ref="errorDialog"></error-dialog>
  </div>
</template>

<script>
import EditableStringAndNumberCell from "./EditableStringAndNumberCell";
import EditableTimeCell from "./EditableTimeCell";
import ErrorDialog from "./ErrorDialog";
import vSelect from "vue-select";
import _ from "lodash";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapGetters, mapState } =
  createNamespacedHelpers("gkmgPortMaster");

export default {
  components: {
    EditableStringAndNumberCell,
    EditableTimeCell,
    vSelect,
    ErrorDialog,
  },
  props: {
    data: { type: Array },
    columns: { type: Array },
    //masterName: { type: String }, 削除機能は使わない見込みであるため、コメントアウト。
    //insertDataPageName: { type: String }, 新規作成機能は使わない見込みであるため、コメントアウト。
    pagination: { type: Boolean, default: false },
    totalPages: { type: Number },
    totalItems: { type: Number },
    currentPage: { type: Number },
    incrementSearch: { type: Boolean, default: true },
    sortable: { type: Boolean, default: true },
    editable: { type: Boolean, default: true },
    viewPageName: { type: String },
    displayItems: { type: Object },
    storedSearchKeyword: { type: String, default: "" },
  },
  data() {
    return {
      searchInput: this.storedSearchKeyword,
      isEditingId: "",
      isEditingOrder: false,
      inputData: [],
      receivedData: [],
      filteredData: [],
      popupActive: false,
      currentPageTemp: this.currentPage,
      isForcedChangeCurrentPage: false,
      /*
       * 削除機能は使わない見込みであるため、コメントアウト。仕様確定時に削除予定。
      deleteTarget: {
        id: "",
        displayName: ""
      },*/
      displayItemsOptions: [
        {
          number: 10,
        },
        {
          number: 20,
        },
        {
          number: 30,
        },
      ],
      lastSearchCondition: {},
      displayItemsTemp: 10,
    };
  },
  created() {
    // initialize attributes
    this.currentPageTemp++;
    this.displayItemsTemp = this.displayItems;
  },
  mounted() {
    if (!this.hasAddonGkmgPortMaster) return;
    this.getGkmgPortMasterAuth();
  },
  watch: {
    data(value) {
      this.receivedData = JSON.parse(JSON.stringify(value));

      this.inputData.splice(0);
      value.forEach((data) => {
        this.inputData.push(data);
      });

      this.filteredData = JSON.parse(JSON.stringify(value));
    },
    searchInput() {
      if (this.incrementSearch) {
        this.callSearch();
      }
    },
    currentPageTemp(value) {
      if (!this.isForcedChangeCurrentPage && this.pagination) {
        let searchCondition = {
          limit: this.displayItems.number,
          page: value - 1,
        };

        this.lastSearchCondition = {
          ...searchCondition,
          name: this.storedSearchKeyword,
        };
        this.$emit("callSearch", searchCondition);
      }
    },
    displayItemsTemp: {
      handler() {
        this.$emit("updateDisplayItems", this.displayItemsTemp.number);
        let searchCondition = {
          limit: this.displayItemsTemp.number,
          page: 0,
        };
        this.isForcedChangeCurrentPage = true;
        this.currentPageTemp = 1;
        this.isForcedChangeCurrentPage = false;

        this.lastSearchCondition = {
          ...searchCondition,
          name: this.storedSearchKeyword,
        };
        this.$emit("callSearch", searchCondition);
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      vesselsData: (state) => state.vesselsData,
    }),
    ...mapGetters(["gkmgPortMasterAuth"]),
    displayItemsText() {
      let from =
        this.receivedData.length != 0
          ? this.currentPage * this.displayItemsTemp.number + 1
          : 0;
      let to =
        this.currentPage * this.displayItemsTemp.number +
        this.receivedData.length;
      let total = this.totalItems;
      return `${from}-${to}/${total}`;
    },
    indexFrom() {
      return this.receivedData.length != 0
        ? this.currentPage * this.displayItemsTemp.number + 1
        : 0;
    },
    dataChanged() {
      return !_.isEqual(this.inputData, this.receivedData);
    },
    searchKeys() {
      return this.columns
        .filter((column) => column.searchable)
        .map((filteredColumns) => filteredColumns.key);
    },
    isShowEditMenu() {
      // this.gkmgPortMasterAuthは元はconst.jsのGKMG_AUTH_MASTERを見ているため、必ずPortMenu.editを持つ
      return this.gkmgPortMasterAuth.PortMenu.edit;
    },
  },
  methods: {
    ...mapActions([
      // "deleteVessel",
      "getGkmgPortMasterAuth",
    ]),
    callSearch() {
      if (this.incrementSearch) {
        this.cancelEdit();
        this.filteredData = this.receivedData.filter((element) => {
          return this.searchKeys.some((key) =>
            element[key] ? element[key].includes(this.searchInput) : false,
          );
        });
      } else {
        let searchCondition = {
          keyword: this.searchInput,
          limit: this.displayItems.number,
          page: 0,
        };
        this.isForcedChangeCurrentPage = true;
        this.currentPageTemp = 1;
        this.isForcedChangeCurrentPage = false;

        this.lastSearchCondition = {
          ...searchCondition,
          name: this.storedSearchKeyword,
        };
        this.$emit("callSearch", searchCondition);
      }
    },
    searchInputEnter(event) {
      if (event.keyCode !== 13 || this.incrementSearch) return;
      this.callSearch();
    },
    clickRow(id) {
      if (!this.isShowEditMenu) {
        return;
      }
      if (this.isEditingOrder) return;
      if (this.editable && id != this.isEditingId) {
        this.cancelEdit();
        this.isEditingId = id;
      } else {
        this.toViewPage(id);
      }
    },
    callSave() {
      let editedRowData =
        this.inputData[
          this.inputData.findIndex((element) => element.id == this.isEditingId)
        ];
      this.$emit("callSave", editedRowData);
      this.isEditingId = "";
    },
    /*
     * 削除機能は仕様上使用しない見込みであるため、コメントアウト。使わないことが確定したのち削除する。
    async callDelete(id) {
      if (this.pagination) {
        this.isForcedChangeCurrentPage = true
        this.currentPageTemp = 1
        this.isForcedChangeCurrentPage = false
      }
      this.popupActive = false
      const firebaseDocId = this.vesselsData.find(el => String(el.data.id) === String(id)).id

      try {
        this.$vs.loading()
        await this.deleteVessel(firebaseDocId)
        this.$vs.loading.close()
        this.$vs.notify({
          title: "データを削除しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-check",
          position: "top-center"
        })
        this.$router.push(
          {
            name: "addon-gkmg-port-master-vessel-master"
          }
        )
      } catch(e) {
        this.$vs.loading.close()
        this.$vs.notify({
          title: "データを削除できませんでした。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square"
        })
      }
    },*/
    callUpdateOrder() {
      this.isEditingOrder = false;
      let sortOrders = this.filteredData.map((rowData, index) => {
        return {
          id: rowData.id,
          sort_order: index,
        };
      });
      this.$emit("callUpdateOrder", sortOrders);
    },
    forceUpdateTable(value) {
      this.searchInput = "";
      this.filteredData = value;
      this.inputData.splice(0);
      JSON.parse(JSON.stringify(this.receivedData)).forEach((data) => {
        this.inputData.push(data);
      });
    },
    setCurrentPageTemp(value) {
      this.currentPageTemp = value;
    },
    cancelEdit() {
      this.isEditingId = "";
      this.inputData.splice(0);
      JSON.parse(JSON.stringify(this.receivedData)).forEach((data) => {
        this.inputData.push(data);
      });
    },
    cancelEditOrder() {
      if (!this.pagination) {
        this.isEditingOrder = "";
        this.filteredData = this.receivedData;
      } else {
        this.isEditingOrder = "";
        this.callSearch();
      }
    },
    clickChangeOrder() {
      if (!this.pagination) {
        this.isEditingOrder = true;
        this.isEditingId = "";
        this.searchInput = "";
        this.filteredData = this.receivedData;
      } else {
        this.isEditingOrder = true;
        this.$emit("callFetchAll");
      }
    },
    /*
     * 削除機能は仕様上使用しない見込みであるため、コメントアウト。使わないことが確定したのち削除する。
    openDeletePopup(rowData) {
      this.deleteTarget = {
        id: rowData.id,
        displayName: rowData[this.columns[1].key],
      }
      this.popupActive = true
    },
    closeDeletePopup() {
      this.popupActive = false
    },*/
    openErrorPopup(title, errorMessage, validationErrors) {
      this.$refs.errorDialog.open(title, errorMessage, validationErrors);
    },
    toViewPage(id) {
      if (!this.editable) {
        this.$router.push({
          name: this.viewPageName,
          params: { itemId: id, lastSearchCondition: this.lastSearchCondition },
        });
      }
    },
    /*
     * 削除機能は仕様上使用しない見込みであるため、コメントアウト。使わないことが確定したのち削除する。
    toInsertPage() {
      this.$router.push({
        name: this.insertDataPageName
      })
    },*/
    generateClassses(columnData) {
      let classObj = {};
      classObj[columnData.key] = true;
      if (Object.prototype.hasOwnProperty.call(columnData, "cellClass")) {
        classObj[columnData.cellClass] = true;
      }
      return classObj;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
#basic-master {
  .flip-list-move {
    transition: transform 0.5s;
  }
  .no-move {
    transition: transform 0s;
  }
  .ghost {
    opacity: 0.5;
    background: $pm-super-light-blue;
  }

  .title {
    font-size: 18px;
  }
  .upper-controller {
    display: flex;
    align-items: center;
    margin-bottom: 40px;
  }
  .display-items-select-box {
    margin-left: 10px;
    width: 145px;
    .vs__search {
      padding: 0px;
    }
  }
  .display-items {
    display: flex;
    align-items: center;
    margin-left: 20px;
  }
  .add-button,
  .order-cancel-button {
    margin-left: auto;
    margin-right: 20px;
  }
  .top-button {
    height: 42px;
  }
  .border-button {
    border: solid 1px $pm-blue;
    .button-inner {
      color: $pm-blue;
      line-height: 1;
    }
  }
  .button-inner {
    display: flex;
    align-items: center;
  }
  .search-input {
    margin: 0px 10px;
  }
  .header {
    font-weight: bold;
  }
  .row {
    min-height: 53px;
    height: fit-content;
    display: flex;
    border-bottom: solid 1px $pm-light-white;
  }
  .content-row {
    justify-content: space-between;
    transition: 0.3s;
    flex-wrap: wrap;
    position: relative;
    &:hover {
      background: $pm-white;
    }
  }
  .main-columns {
    display: flex;
    flex-grow: 1;
  }
  .cell {
    display: flex;
    align-items: center;

    &.index {
      min-width: 40px;
      max-width: 40px;
    }
    &.name {
      min-width: 80px;
      max-width: 80px;
    }
    &.type {
      min-width: 60px;
      max-width: 60px;
    }
    &.loading_weight {
      min-width: 80px;
      max-width: 80px;
    }
    &.boarding_number {
      min-width: 80px;
      max-width: 80px;
    }
    &.company_name {
      min-width: 100px;
      max-width: 100px;
    }
    &.default_vehicles_count {
      min-width: 80px;
      max-width: 80px;
    }
    &.head_count {
      min-width: 100px;
      max-width: 100px;
    }
    &.required_note {
      width: 11vw;
      min-width: 150px;
      max-width: 300px;
    }
    &.cautionary_note {
      width: 11vw;
      min-width: 150px;
      max-width: 300px;
    }

    &.created_at {
      min-width: 160px;
      max-width: 160px;
    }
    &.updated_at {
      min-width: 160px;
      max-width: 160px;
    }
  }

  .vs-con-dropdown {
    position: absolute;
    right: 0;
    top: 32%;
  }

  .row.focused {
    background: $pm-white;
  }
  .main-columns.clickable {
    cursor: pointer;
  }
  .row.ordered:hover {
    cursor: grab !important;
  }
  .row.dragged:hover {
    cursor: move;
  }
  .control-button {
    margin-right: 10px;
    white-space: nowrap;
  }

  .master-pagination {
    margin-top: 20px;
  }

  .more-button:hover {
    cursor: pointer;
  }
}
.basic-master-popup {
  .popup-button {
    margin-left: 10px;
  }
  .button-area {
    width: fit-content;
    margin-top: 20px;
    margin-left: auto;
  }
}
.more-button-dropdown {
  width: 90px;
}
</style>
